module.exports = [
  {
    en: 'General',
    vocabularies: [
      {
        en: 'Yes',
        ru: 'да',
        vocal: 'da',
      },
      {
        en: 'No',
        ru: 'нет',
        vocal: 'net',
      },
      {
        en: 'perhaps',
        ru: 'может быть',
        vocal: 'mо̒shet byt',
      },
      {
        en: 'please',
        ru: 'пожалуйста',
        vocal: 'pashа́lujßta',
      },
      {
        en: 'thank you',
        ru: 'спасибо',
        vocal: 'ßpaßi̒ba',
      },
      {
        en: 'Excuse me',
        ru: 'извините',
        vocal: 'iswini̒te',
      },
      {
        en: 'all right',
        ru: 'ясно, ладно',
        vocal: 'jа́ßna, lа́dna',
      },
      {
        en: 'I (do not) understand',
        ru: 'Я (не) понимаю',
        vocal: 'Ja (ni) panimа́ju',
      },
      {
        en: 'Do you speak German?',
        ru: 'Вы говорите по-немецки?',
        vocal: 'Wy gawari̒te pa-nimе́tzki?',
      },
      {
        en: 'I do not speak German',
        ru: 'Я не говорю по-немецки',
        vocal: 'Ja ni gawarju̒ pa-nimе́tzki.',
      },
      {
        en: 'Help!',
        ru: 'Помогите!',
        vocal: 'Pamagi̒te!',
      },
      {
        en: 'A bit slower please',
        ru: 'Немного помедленнее, пожалуйста',
        vocal: 'Nimnо́ga pamе́dlinije, pashа́lujßta',
      },
      {
        en: 'Bless you!',
        ru: 'Будь здоров(а)! Будьте здоровы!',
        vocal: 'Bud sdarо́w(a)! Bu̒dtje sdarо́wy!',
      },
      {
        en: 'Cheers!',
        ru: 'Твое (Ваше) здоровье!',
        vocal: 'Twajо́ (Wа́sche) sdarо́wje!',
      },
      {
        en: 'Where',
        ru: 'где',
        vocal: 'gde',
      },
      {
        en: 'When',
        ru: 'когда',
        vocal: 'kagdа́',
      },
      {
        en: 'Who',
        ru: 'кто',
        vocal: 'kto',
      },
      {
        en: 'Why',
        ru: 'почему',
        vocal: 'patschimu̒',
      },
    ],
  },
  {
    en: 'Introduction',
    vocabularies: [
      {
        en: 'Surname',
        ru: 'имя',
        vocal: 'i̒mja',
      },
      {
        en: "What's your name?",
        ru: 'Как Вас зовут?',
        vocal: 'Kak waß sawu̒t?',
      },
      {
        en: 'My name is…',
        ru: 'Меня зовут...',
        vocal: 'Minjа́ sawu̒t…',
      },
      {
        en: 'I am…',
        ru: 'Я ...',
        vocal: 'Ja …',
      },
      {
        en: "It's nice to meet you",
        ru: 'Приятно с Вами познакомиться',
        vocal: 'Prijа́tna ß wа́mi pasnakо́mitza',
      },
      {
        en: 'I am X years old',
        ru: 'Мне X лет',
        vocal: 'Mne X let.',
      },
      {
        en: "I'm from…",
        ru: 'Я из ...',
        vocal: 'Ja is …',
      },
      {
        en: 'How old are they?',
        ru: 'Сколько Вам лет?',
        vocal: 'ßkо́lka wam let?',
      },
      {
        en: 'Where do they work?',
        ru: 'Где Вы работаете?',
        vocal: 'Gde wy rabо́taiti?',
      },
      {
        en: 'Where are you from?',
        ru: 'Откуда Вы?',
        vocal: 'Atku̒da wy?',
      },
      {
        en: 'What brings you here?',
        ru: 'Что привело Вас сюда?',
        vocal: 'Schto priwilо́ waß ßjudа́?',
      },
      {
        en: 'How was your trip?',
        ru: 'Как прошла Ваша поездка?',
        vocal: 'Kak praschlа́ wа́scha pajе́sdka?',
      },
      {
        en: 'Do you have a good time?',
        ru: 'Вы хорошо проводите время?',
        vocal: 'Wy charaschо́ prawо́dite wrе́mja?',
      },
      {
        en: 'What do you think of …?',
        ru: 'Что Вы думаете о ...?',
        vocal: 'Schto wy du̒maiti a ...?',
      },
      {
        en: 'My friends call me …',
        ru: 'Мои друзья зовут меня ...',
        vocal: 'Mai̒ drusjа́ sawu̒t minjа́ ...',
      },
      {
        en: 'Do we know each other?',
        ru: 'Мы знакомы?',
        vocal: 'My snakо́my?',
      },
      {
        en: 'This is (name)',
        ru: 'Это (имя)',
        vocal: 'Äta (i̒mja)',
      },
      {
        en: 'How was your weekend?',
        ru: 'Как прошли Ваши выходные?',
        vocal: 'Kak praschli̒ wа́schy wychadny̒je?',
      },
    ],
  },
  {
    en: 'Welcome / Send-off',
    vocabularies: [
      {
        en: 'Hi',
        ru: 'Здорого',
        vocal: 'Zdorovo',
      },
      {
        en: 'Good Morning',
        ru: 'Доброе утро',
        vocal: 'Dо́braje u̒tra',
      },
      {
        en: 'Good day',
        ru: 'Добрый день. Здравствуй(те)',
        vocal: 'Dо́bryj den. Sdrа́ßtwuj(ti)',
      },
      {
        en: 'Good evening',
        ru: 'Добрый вечер',
        vocal: 'Dо́bryj wе́tschir',
      },
      {
        en: 'Good night',
        ru: 'Спокойной ночи',
        vocal: 'ßpakо́jnaj nо́tschi',
      },
      {
        en: 'Bye',
        ru: 'Пока',
        vocal: 'Pakа́',
      },
      {
        en: 'Goodbye',
        ru: 'До свидания',
        vocal: 'Da ßwidа́nja',
      },
      {
        en: 'How are you?',
        ru: 'Как у Вас дела?',
        vocal: 'Kak u waß di̒la?',
      },
      {
        en: 'Good',
        ru: 'хорошо',
        vocal: 'charaschо́',
      },
      {
        en: 'Bad',
        ru: 'плохо',
        vocal: 'plо́cha',
      },
      {
        en: 'Hey, Hello',
        ru: 'Привет',
        vocal: 'Priwе́t',
      },
      {
        en: 'How are you?',
        ru: 'Как дела?',
        vocal: 'Kak di̒la?',
      },
      {
        en: "What's going on?",
        ru: 'Что нового?',
        vocal: 'Schto nо́wawa?',
      },
      {
        en: 'Nice to see you',
        ru: 'Рад(а) Вас видеть.',
        vocal: 'Rа́d(a) waß wi̒det.',
      },
      {
        en: 'Nice to meet you',
        ru: 'Приятно с Вами познакомиться',
        vocal: 'Prijа́tna ß wа́mi pasnakо́mitza',
      },
      {
        en: 'Take care',
        ru: 'Всего хорошего',
        vocal: 'Vsego khoroshego',
      },
      {
        en: 'Long time no see',
        ru: 'Давно не виделись',
        vocal: 'Dawnо́ ni wi̒dilis',
      },
      {
        en: "What's up?",
        ru: 'Как обстоят дела?',
        vocal: 'Kak abßtajа́t di̒la?',
      },
    ],
  },
  {
    en: 'travel',
    vocabularies: [
      {
        en: 'I would like…',
        ru: 'Я бы хотел(а)...',
        vocal: 'Ja by chatе́l(a)…',
      },
      {
        en: 'Where are the toilets?',
        ru: 'Где здесь туалет?',
        vocal: 'Gde sdes tualе́t?',
      },
      {
        en: 'What time is it?',
        ru: 'Который час?',
        vocal: 'Katо́ryj tschaß?',
      },
      {
        en: 'I stay at ...',
        ru: 'Я ночую у ...',
        vocal: 'Ja natschu̒ju u ...',
      },
      {
        en: 'I visit family',
        ru: 'Я навещаю семью',
        vocal: 'Ja nawischtschа́ju ßimju̒',
      },
      {
        en: 'I am here for X days',
        ru: 'Я здесь на X дня (дней)',
        vocal: 'Ja sdes na X dnja (dnej)',
      },
      {
        en: 'Do you have a card?',
        ru: 'У вас есть карта?',
        vocal: 'U waß jeßt kа́rta?',
      },
      {
        en: 'passport',
        ru: 'загранпаспорт',
        vocal: 'sagranpа́ßpart',
      },
      {
        en: 'Airport',
        ru: 'аэропорт',
        vocal: 'aärapo̒rt',
      },
      {
        en: 'port',
        ru: 'порт, гавань',
        vocal: 'port, gа́wan',
      },
      {
        en: 'safety',
        ru: 'безопасность',
        vocal: 'bisapа́ßnaßt',
      },
      {
        en: 'plane',
        ru: 'самолёт',
        vocal: 'ßamaljo̒t',
      },
      {
        en: 'train',
        ru: 'поезд',
        vocal: 'po̒jisd',
      },
      {
        en: 'ship',
        ru: 'корабль',
        vocal: 'karа́bl',
      },
      {
        en: 'bicycle',
        ru: 'велосипед',
        vocal: 'wilaßipе́d',
      },
      {
        en: 'motorcycle',
        ru: 'мотоцикл',
        vocal: 'matatzy̒kl',
      },
      {
        en: 'bus',
        ru: 'автобус',
        vocal: 'afto̒buß',
      },
      {
        en: 'to fly',
        ru: 'лететь',
        vocal: 'litе́t',
      },
      {
        en: 'drive',
        ru: 'ехать',
        vocal: 'jе́chat',
      },
      {
        en: 'sailing',
        ru: 'ходить под парусом',
        vocal: 'chadi̒t pad pа́rußam',
      },
    ],
  },
  {
    en: 'Directions',
    vocabularies: [
      {
        en: 'Left',
        ru: 'слева',
        vocal: 'ßlе́wa',
      },
      {
        en: 'right',
        ru: 'справа',
        vocal: 'ßprа́wa',
      },
      {
        en: 'here',
        ru: 'здесь, тут',
        vocal: 'sdes, tut',
      },
      {
        en: 'there',
        ru: 'там',
        vocal: 'tam',
      },
      {
        en: 'back',
        ru: 'обратно, назад',
        vocal: 'abrа́tna, nasа́d',
      },
      {
        en: 'high',
        ru: 'вверх',
        vocal: 'wwerch',
      },
      {
        en: 'down',
        ru: 'вниз',
        vocal: 'wnis',
      },
      {
        en: 'straight',
        ru: 'прямо',
        vocal: 'prjа́ma',
      },
      {
        en: 'place',
        ru: 'населённый пункт, место',
        vocal: 'naßiljo̒nyj punkt, mе́sta',
      },
      {
        en: 'Where is…?',
        ru: 'Где находится ...?',
        vocal: 'Gde nacho̒ditza …?',
      },
      {
        en: 'How do I get to…?',
        ru: 'Как мне пройти к ...?',
        vocal: 'Kak mnje prajti̒ k …?',
      },
      {
        en: 'Seeking ... street.',
        ru: 'Я ищу улицу ... .',
        vocal: 'Ja ischtschu̒ u̒litzu … .',
      },
      {
        en: 'around the corner',
        ru: 'за углом',
        vocal: 'sa uglo̒m',
      },
      {
        en: 'far',
        ru: 'далеко',
        vocal: 'daliko̒',
      },
      {
        en: 'near',
        ru: 'недалеко от, близко от',
        vocal: 'nidaliko̒ at, bli̒ska at',
      },
      {
        en: 'across from',
        ru: 'напротив',
        vocal: 'napro̒tif',
      },
      {
        en: 'follow me',
        ru: 'Идите за мной',
        vocal: 'Idi̒te sa mnoj',
      },
      {
        en: 'next X',
        ru: 'рядом с X',
        vocal: 'rjа́dam ß X',
      },
      {
        en: 'pass',
        ru: 'проходить мимо',
        vocal: 'prachadi̒t mi̒ma',
      },
      {
        en: 'between',
        ru: 'между',
        vocal: 'mе́shdu',
      },
    ],
  },
  {
    en: 'Times / data',
    vocabularies: [
      {
        en: 'now',
        ru: 'сейчас',
        vocal: 'ßijtschа́ß',
      },
      {
        en: 'today',
        ru: 'сегодня',
        vocal: 'ßiwo̒dnja',
      },
      {
        en: 'morning',
        ru: 'завтра',
        vocal: 'sа́ftra',
      },
      {
        en: 'yesterday',
        ru: 'вчера',
        vocal: 'ftschirа́',
      },
      {
        en: 'second',
        ru: 'секунда',
        vocal: 'ßiku̒nda',
      },
      {
        en: 'minute',
        ru: 'минута',
        vocal: 'minu̒ta',
      },
      {
        en: 'hour',
        ru: 'час',
        vocal: 'tschaß',
      },
      {
        en: 'Day',
        ru: 'день',
        vocal: 'den',
      },
      {
        en: 'week',
        ru: 'неделя',
        vocal: 'nidе́lja',
      },
      {
        en: 'month',
        ru: 'месяц',
        vocal: 'mе́ßitz',
      },
      {
        en: 'year',
        ru: 'год',
        vocal: 'god',
      },
      {
        en: 'early',
        ru: 'рано',
        vocal: 'rа́na',
      },
      {
        en: 'late',
        ru: 'поздно',
        vocal: 'po̒sdna',
      },
      {
        en: 'Monday',
        ru: 'понедельник',
        vocal: 'panidе́lnik',
      },
      {
        en: 'Tuesday',
        ru: 'вторник',
        vocal: 'fto̒rnik',
      },
      {
        en: 'Wednesday',
        ru: 'среда',
        vocal: 'ßridа́',
      },
      {
        en: 'Thursday',
        ru: 'четверг',
        vocal: 'tschitwе́rg',
      },
      {
        en: 'Friday',
        ru: 'пятница',
        vocal: 'pjа́tnitza',
      },
      {
        en: 'Saturday',
        ru: 'суббота',
        vocal: 'ßubo̒ta',
      },
      {
        en: 'Sunday',
        ru: 'воскресенье',
        vocal: 'waskrißе́nje',
      },
      {
        en: 'spring',
        ru: 'весна',
        vocal: 'wisnа́',
      },
      {
        en: 'summer',
        ru: 'лето',
        vocal: 'lе́ta',
      },
      {
        en: 'autumn',
        ru: 'осень',
        vocal: 'o̒ßin',
      },
      {
        en: 'winter',
        ru: 'зима',
        vocal: 'simа́',
      },
      {
        en: 'January',
        ru: 'январь',
        vocal: 'janwа́r',
      },
      {
        en: 'February',
        ru: 'февраль',
        vocal: 'fiwrа́l',
      },
      {
        en: 'March',
        ru: 'март',
        vocal: 'mart',
      },
      {
        en: 'April',
        ru: 'апрель',
        vocal: 'aprе́l',
      },
      {
        en: 'May',
        ru: 'май',
        vocal: 'maj',
      },
      {
        en: 'June',
        ru: 'июнь',
        vocal: 'iju̒n',
      },
      {
        en: 'July',
        ru: 'июль',
        vocal: 'iju̒l',
      },
      {
        en: 'August',
        ru: 'август',
        vocal: 'а́wgust',
      },
      {
        en: 'September',
        ru: 'сентябрь',
        vocal: 'ßintjа́br',
      },
      {
        en: 'October',
        ru: 'октябрь',
        vocal: 'aktjа́br',
      },
      {
        en: 'November',
        ru: 'ноябрь',
        vocal: 'najа́br',
      },
      {
        en: 'December',
        ru: 'декабрь',
        vocal: 'dikа́br',
      },
      {
        en: 'time of day',
        ru: 'время',
        vocal: 'wrе́mja',
      },
      {
        en: 'decade',
        ru: 'десятилетие',
        vocal: 'dißjatilе́tije',
      },
      {
        en: 'century',
        ru: 'столетие, век',
        vocal: 'ßtalе́tije, wek',
      },
    ],
  },
  {
    en: 'places',
    vocabularies: [
      {
        en: 'Supermarket',
        ru: 'супермаркет',
        vocal: 'ßupirmа́rkit',
      },
      {
        en: 'hospital',
        ru: 'больница',
        vocal: 'balni̒tza',
      },
      {
        en: 'Bank',
        ru: 'банк',
        vocal: 'bank',
      },
      {
        en: 'hotel',
        ru: 'гостиница, отель',
        vocal: 'gaßti̒nitza, atä̒l',
      },
      {
        en: 'bar',
        ru: 'бар',
        vocal: 'bar',
      },
      {
        en: 'pharmacy',
        ru: 'аптека',
        vocal: 'aptе́ka',
      },
      {
        en: 'Beach',
        ru: 'пляж',
        vocal: 'pljash',
      },
      {
        en: 'restaurant',
        ru: 'ресторан',
        vocal: 'rißtarа́n',
      },
      {
        en: 'bakery',
        ru: 'булочная',
        vocal: 'bu̒latschnaja',
      },
      {
        en: 'Bus stop',
        ru: 'автобусная остановка',
        vocal: 'afto̒bußnaja aßtano̒fka',
      },
      {
        en: 'church',
        ru: 'церковь',
        vocal: 'tzä̒rkaf',
      },
      {
        en: 'movie theater',
        ru: 'кинотеатр',
        vocal: 'kinatiа́tr',
      },
      {
        en: 'Gas station',
        ru: 'заправочная станция (заправка)',
        vocal: 'saprа́watschnaja ßtа́ntzija (saprа́fka)',
      },
      {
        en: 'museum',
        ru: 'музей',
        vocal: 'musе́j',
      },
      {
        en: 'Police station',
        ru: 'полицейский участок',
        vocal: 'palitzä̒jskij utschа́stak',
      },
      {
        en: 'school',
        ru: 'школа',
        vocal: 'schko̒la',
      },
      {
        en: 'space',
        ru: 'площадь',
        vocal: 'plo̒schtschad',
      },
      {
        en: 'zoo',
        ru: 'зоопарк',
        vocal: 'saapа́rk',
      },
    ],
  },
  {
    en: 'shopping',
    vocabularies: [
      {
        en: 'expensive',
        ru: 'дорого',
        vocal: 'do̒raga',
      },
      {
        en: 'cheap',
        ru: 'дёшево',
        vocal: 'djo̒schewa',
      },
      {
        en: 'free',
        ru: 'бесплатно',
        vocal: 'bißplа́tna',
      },
      {
        en: 'How much is it?',
        ru: 'Сколько это стоит?',
        vocal: 'ßko̒lka ä̒ta ßto̒it?',
      },
      {
        en: 'cashier',
        ru: 'кассир',
        vocal: 'kaßi̒r',
      },
      {
        en: 'Trolley / Cart',
        ru: 'тележка / корзинка для покупок',
        vocal: 'tilе́shka / karsi̒nka dlja paku̒pak',
      },
      {
        en: 'bag',
        ru: 'сумка',
        vocal: 'ßu̒mka',
      },
      {
        en: 'guarantee',
        ru: 'гарантия',
        vocal: 'garа́ntija',
      },
      {
        en: 'refund policy',
        ru: 'право возврата товара',
        vocal: 'prа́wa waswrа́ta tawа́ra',
      },
      {
        en: 'debit card',
        ru: 'карта клиента',
        vocal: 'kа́rta klijе́nta',
      },
      {
        en: 'VAT receipt',
        ru: 'квитанция с НДС',
        vocal: 'kwitа́ntzija s än dä äs',
      },
      {
        en: 'Discount',
        ru: 'скидка',
        vocal: 'ßki̒dka',
      },
      {
        en: 'corridor',
        ru: 'ряд',
        vocal: 'rjad',
      },
      {
        en: 'shelf',
        ru: 'полка',
        vocal: 'po̒lka',
      },
      {
        en: 'changing room',
        ru: 'примерочная кабина',
        vocal: 'primе́ratschnaja kabi̒na',
      },
      {
        en: 'delivery',
        ru: 'поставка',
        vocal: 'pastа́fka',
      },
      {
        en: 'Sale',
        ru: 'сезонная распродажа',
        vocal: 'ßiso̒naja raspradа́sha',
      },
      {
        en: 'Excuse me, do you work here?',
        ru: 'Извините, Вы здесь работаете?',
        vocal: 'Iswini̒te, wy sdes rabo̒taite?',
      },
    ],
  },
  {
    en: 'In the restaurant',
    vocabularies: [
      {
        en: 'A table for X people, please.',
        ru: 'Столик на X человек(а), пожалуйста.',
        vocal: 'ßto̒lik na X tschelowе́k(a), pashа́lujßta.',
      },
      {
        en: 'I would like to order.',
        ru: 'Я бы хотел(а) заказать.',
        vocal: 'Ja by chatе́l(a) sakasа́t.',
      },
      {
        en: 'Can I have the card?',
        ru: 'Дайте меню, пожалуйста.',
        vocal: 'Dа́jte menju̒, pashа́lujßta.',
      },
      {
        en: 'The Bill please.',
        ru: 'Счёт, пожалуйста.',
        vocal: 'ßtschjot, pashа́lujßta.',
      },
      {
        en: 'breakfast',
        ru: 'завтрак',
        vocal: 'sа́ftrak',
      },
      {
        en: 'dine',
        ru: 'обед',
        vocal: 'abе́d',
      },
      {
        en: 'dinner',
        ru: 'ужин',
        vocal: 'u̒shin',
      },
      {
        en: 'cutlery',
        ru: 'столовые приборы',
        vocal: 'stalo̒wyje pribo̒ry',
      },
      {
        en: 'napkin',
        ru: 'салфетка',
        vocal: 'ßalfе́tka',
      },
      {
        en: 'brunch',
        ru: 'второй завтрак',
        vocal: 'ftaro̒j sа́ftrak',
      },
      {
        en: 'main course',
        ru: 'основное блюдо',
        vocal: 'aßnawno̒je blju̒da',
      },
      {
        en: 'dessert',
        ru: 'десерт',
        vocal: 'dißе́rt',
      },
      {
        en: 'tip',
        ru: 'чаевые',
        vocal: 'tschajiwy̒je',
      },
      {
        en: 'garnish',
        ru: 'гарнир',
        vocal: 'garni̒r',
      },
      {
        en: 'beverages',
        ru: 'напитки',
        vocal: 'napi̒tki',
      },
      {
        en: 'all you can eat',
        ru: 'шведский стол',
        vocal: 'schwе́dskij ßtol',
      },
      {
        en: 'Happy Hour',
        ru: 'акция "счастливые часы"',
        vocal: 'а́kzija "schtschaßli̒wyje tschaßy̒"',
      },
      {
        en: 'appetizer',
        ru: 'закуски',
        vocal: 'saku̒ßki',
      },
    ],
  },
  {
    en: 'At the hotel',
    vocabularies: [
      {
        en: 'room',
        ru: 'номер, комната',
        vocal: 'no̒mir, ko̒mnata',
      },
      {
        en: 'room service',
        ru: 'обслуживание номеров',
        vocal: 'abslu̒shiwanije namiro̒f',
      },
      {
        en: 'bathroom',
        ru: 'ванная комната',
        vocal: 'wа́naja ko̒mnata',
      },
      {
        en: 'bed',
        ru: 'кровать',
        vocal: 'krawа́t',
      },
      {
        en: 'bedroom',
        ru: 'спальня',
        vocal: 'ßpа́lnja',
      },
      {
        en: 'floor',
        ru: 'этаж',
        vocal: 'ätа́sh',
      },
      {
        en: 'elevator',
        ru: 'лифт',
        vocal: 'lift',
      },
      {
        en: 'reception',
        ru: 'стойка администратора (ресепшен)',
        vocal: 'ßto̒jka adminißtrа́tara (rißä̒pschen)',
      },
      {
        en: 'towel',
        ru: 'полотенце',
        vocal: 'palatе́ntze',
      },
      {
        en: 'Outbuildings',
        ru: 'соседние комнаты',
        vocal: 'ßaßе́dnije ko̒mnaty',
      },
      {
        en: 'baggage',
        ru: 'багаж',
        vocal: 'bagа́sh',
      },
      {
        en: 'page',
        ru: 'посыльный',
        vocal: 'paßy̒lnyj',
      },
      {
        en: 'kitchenette',
        ru: 'миникухня',
        vocal: 'miniku̒chnja',
      },
      {
        en: 'bed linen',
        ru: 'постельное бельё',
        vocal: 'paßtе́lnaje biljo̒',
      },
      {
        en: 'valet',
        ru: 'камердинер',
        vocal: 'kamerdi̒ner',
      },
      {
        en: 'lobby',
        ru: 'лобби',
        vocal: 'lo̒bi',
      },
      {
        en: 'deposit',
        ru: 'аванс',
        vocal: 'awа́nß',
      },
      {
        en: 'check in',
        ru: 'заселиться в гостиницу',
        vocal: 'saßili̒tza w gaßti̒nitzu',
      },
      {
        en: 'check-Out',
        ru: 'выехать из гостиницы',
        vocal: 'wy̒jechat is gaßti̒nitzy',
      },
      {
        en: 'free',
        ru: 'бесплатно',
        vocal: 'bißplа́tna',
      },
    ],
  },
  {
    en: 'numbers',
    vocabularies: [
      {
        en: 'one',
        ru: 'один',
        vocal: 'adi̒n',
      },
      {
        en: 'Two',
        ru: 'два',
        vocal: 'dwa',
      },
      {
        en: 'Three',
        ru: 'три',
        vocal: 'tri',
      },
      {
        en: 'Four',
        ru: 'четыре',
        vocal: 'tschity̒ri',
      },
      {
        en: 'five',
        ru: 'пять',
        vocal: 'pjat',
      },
      {
        en: 'six',
        ru: 'шесть',
        vocal: 'scheßt',
      },
      {
        en: 'seven',
        ru: 'семь',
        vocal: 'ßem',
      },
      {
        en: 'eight',
        ru: 'восемь',
        vocal: 'wo̒ßim',
      },
      {
        en: 'nine',
        ru: 'девять',
        vocal: 'dе́wjat',
      },
      {
        en: 'ten',
        ru: 'десять',
        vocal: 'dе́ßjat',
      },
      {
        en: 'Eleven',
        ru: 'одиннадцать',
        vocal: 'adi̒natzat',
      },
      {
        en: 'Twelve',
        ru: 'двенадцать',
        vocal: 'dwinа́tzat',
      },
      {
        en: 'Thirteen',
        ru: 'тринадцать',
        vocal: 'trinа́tzat',
      },
      {
        en: 'fourteen',
        ru: 'четырнадцать',
        vocal: 'tschity̒rnatzat',
      },
      {
        en: 'Fifteen',
        ru: 'пятнадцать',
        vocal: 'pitnа́tzat',
      },
      {
        en: 'Sixteen',
        ru: 'шестнадцать',
        vocal: 'schyßnа́tzat',
      },
      {
        en: 'Seventeen',
        ru: 'семнадцать',
        vocal: 'ßimnа́tzat',
      },
      {
        en: 'Eighteen',
        ru: 'восемнадцать',
        vocal: 'waßimnа́tzat',
      },
      {
        en: 'Nineteen',
        ru: 'девятнадцать',
        vocal: 'diwjatnа́tzat',
      },
      {
        en: 'Twenty',
        ru: 'двадцать',
        vocal: 'dwа́tzat',
      },
      {
        en: 'Thirty',
        ru: 'тридцать',
        vocal: 'tri̒tzat',
      },
      {
        en: 'Fourty',
        ru: 'сорок',
        vocal: 'ßo̒rak',
      },
      {
        en: 'Fifty',
        ru: 'пятьдесят',
        vocal: 'pidißjа́t',
      },
      {
        en: 'sixty',
        ru: 'шестьдесят',
        vocal: 'schyßdißjа́t',
      },
      {
        en: 'Siebzieg',
        ru: 'семьдесят',
        vocal: 'ßе́mdißat',
      },
      {
        en: 'eighty',
        ru: 'восемьдесят',
        vocal: 'wo̒ßimdißat',
      },
      {
        en: 'Ninety',
        ru: 'девяносто',
        vocal: 'diwino̒ßta',
      },
      {
        en: 'Hundred',
        ru: 'сто',
        vocal: 'ßto',
      },
      {
        en: 'two hundred',
        ru: 'двести',
        vocal: 'dwе́ßti',
      },
      {
        en: 'thousand',
        ru: 'тысяча',
        vocal: 'ty̒ßitscha',
      },
      {
        en: 'Two thousand',
        ru: 'две тысячи',
        vocal: 'dwe ty̒ßitschi',
      },
      {
        en: 'million',
        ru: 'миллион',
        vocal: 'milio̒n',
      },
      {
        en: 'billion',
        ru: 'миллиард',
        vocal: 'miliа́rd',
      },
      {
        en: 'first (r)',
        ru: 'первая (первый)',
        vocal: 'pе́rwaja(pе́rwyj)',
      },
      {
        en: 'second (r)',
        ru: 'вторая (второй)',
        vocal: 'ftarа́ja (ftaro̒j)',
      },
      {
        en: 'third (r)',
        ru: 'третья (третий)',
        vocal: 'trе́tja (trе́tij)',
      },
      {
        en: 'fourth (r)',
        ru: 'четвёртая (четвёртый)',
        vocal: 'tschitwjo̒rtaja (tschitwjo̒rtyj)',
      },
      {
        en: 'fifth)',
        ru: 'пятая (пятый)',
        vocal: 'pjа́taja (pjа́tyj)',
      },
      {
        en: 'sixth (r)',
        ru: 'шестая (шестой)',
        vocal: 'scheßtа́ja (scheßto̒j)',
      },
      {
        en: 'seventh)',
        ru: 'седьмая (седьмой)',
        vocal: 'ßedmа́ja (ßedmo̒j)',
      },
    ],
  },
  {
    en: 'personal pronoun',
    vocabularies: [
      {
        en: 'I',
        ru: 'я',
        vocal: 'ja',
      },
      {
        en: 'you',
        ru: 'ты',
        vocal: 'ty',
      },
      {
        en: 'he',
        ru: 'он',
        vocal: 'on',
      },
      {
        en: 'they',
        ru: 'она',
        vocal: 'anа́',
      },
      {
        en: 'it',
        ru: 'оно',
        vocal: 'ano̒',
      },
      {
        en: 'we',
        ru: 'мы',
        vocal: 'my',
      },
      {
        en: 'her',
        ru: 'вы',
        vocal: 'wy',
      },
      {
        en: 'they',
        ru: 'они',
        vocal: 'ani̒',
      },
    ],
  },
  {
    en: 'Important words',
    vocabularies: [
      {
        en: 'thing',
        ru: 'вещь, предмет',
        vocal: 'wetschsch, pridmе́t',
      },
      {
        en: 'for sure',
        ru: 'безопасный',
        vocal: 'bisapа́ßnyj',
      },
      {
        en: 'and',
        ru: 'и',
        vocal: 'i',
      },
      {
        en: 'or',
        ru: 'или',
        vocal: 'i̒li',
      },
      {
        en: 'because',
        ru: 'потому что',
        vocal: 'patamu̒ schta',
      },
      {
        en: 'Life',
        ru: 'жизнь',
        vocal: 'shysn',
      },
      {
        en: 'government',
        ru: 'правительство',
        vocal: 'prawi̒telßtwa',
      },
      {
        en: 'child',
        ru: 'ребёнок',
        vocal: 'ribjo̒nak',
      },
      {
        en: 'company',
        ru: 'фирма',
        vocal: 'fi̒rma',
      },
      {
        en: 'group',
        ru: 'группа',
        vocal: 'gru̒pa',
      },
      {
        en: 'Age',
        ru: 'возраст',
        vocal: 'wo̒sraßt',
      },
      {
        en: 'moon',
        ru: 'луна (Himmelskörper, Vollmond), месяц (Neumond)',
        vocal: 'lunа́, mе́ßitz',
      },
      {
        en: 'Sun',
        ru: 'солнце',
        vocal: 'ßo̒lntzä',
      },
      {
        en: 'automobile',
        ru: 'машина, автомобиль',
        vocal: 'maschy̒na, aftamabi̒l',
      },
      {
        en: 'book',
        ru: 'книга',
        vocal: 'kni̒ga',
      },
      {
        en: 'world',
        ru: 'мир',
        vocal: 'mir',
      },
      {
        en: 'family',
        ru: 'семья',
        vocal: 'ßimjа́',
      },
      {
        en: 'friend',
        ru: 'друг',
        vocal: 'drug',
      },
      {
        en: 'law',
        ru: 'закон',
        vocal: 'sako̒n',
      },
    ],
  },
  {
    en: 'Human / body',
    vocabularies: [
      {
        en: 'man',
        ru: 'мужчина',
        vocal: 'muschtschi̒na',
      },
      {
        en: 'woman',
        ru: 'женщина',
        vocal: 'shе́nschtschina',
      },
      {
        en: 'Boy',
        ru: 'мальчик',
        vocal: 'mа́ltschik',
      },
      {
        en: 'girl',
        ru: 'девочка',
        vocal: 'dе́watschka',
      },
      {
        en: 'poor',
        ru: 'рука',
        vocal: 'rukа́',
      },
      {
        en: 'hand',
        ru: 'рука, ладонь',
        vocal: 'rukа́, lado̒n',
      },
      {
        en: 'leg',
        ru: 'нога',
        vocal: 'nagа́',
      },
      {
        en: 'foot',
        ru: 'нога, ступня',
        vocal: 'nagа́, ßtupnjа́',
      },
      {
        en: 'eye',
        ru: 'глаз',
        vocal: 'glas',
      },
      {
        en: 'head',
        ru: 'голова',
        vocal: 'galawа́',
      },
      {
        en: 'brain',
        ru: 'мозг',
        vocal: 'mosg',
      },
      {
        en: 'nose',
        ru: 'нос',
        vocal: 'nos',
      },
      {
        en: 'ear',
        ru: 'ухо',
        vocal: 'u̒cha',
      },
      {
        en: 'hair',
        ru: 'во��ос(ы)',
        vocal: 'wo̒laßy',
      },
      {
        en: 'eyebrow',
        ru: 'бровь',
        vocal: 'brof',
      },
      {
        en: 'lips',
        ru: 'губы',
        vocal: 'gu̒by',
      },
      {
        en: 'finger',
        ru: 'палец (Pl. пальцы)',
        vocal: 'pа́litz (Pl. pа́ltzy)',
      },
      {
        en: 'skeleton',
        ru: 'скелет',
        vocal: 'skilе́t',
      },
      {
        en: 'bone',
        ru: 'кость (Pl. кости)',
        vocal: 'koßt (Pl. ko̒ßti)',
      },
      {
        en: 'skin',
        ru: 'кожа',
        vocal: 'ko̒sha',
      },
    ],
  },
  {
    en: 'important verbs',
    vocabularies: [
      {
        en: 'be',
        ru: 'быть',
        vocal: 'byt',
      },
      {
        en: 'to get',
        ru: 'получать (получить)',
        vocal: 'palutschа́t (palutschi̒t)',
      },
      {
        en: 'give',
        ru: 'давать (дать)',
        vocal: 'dawа́t (dat)',
      },
      {
        en: 'Life',
        ru: 'жить',
        vocal: 'shyt',
      },
      {
        en: 'do',
        ru: 'делать',
        vocal: 'dе́lat',
      },
      {
        en: 'go',
        ru: 'идти, ходить',
        vocal: 'idti̒, chadi̒t',
      },
      {
        en: 'to use',
        ru: 'использовать',
        vocal: 'ißpo̒lsawat',
      },
      {
        en: 'eat',
        ru: 'есть, кушать',
        vocal: 'jeßt, ku̒schat',
      },
      {
        en: 'think',
        ru: 'думать',
        vocal: 'du̒mat',
      },
      {
        en: 'come',
        ru: 'приходить (прийти)',
        vocal: 'prichadi̒t (prijti̒)',
      },
      {
        en: 'to have',
        ru: 'иметь',
        vocal: 'imе́t',
      },
      {
        en: 'to do',
        ru: 'делать',
        vocal: 'dе́lat',
      },
      {
        en: 'say',
        ru: 'говорить, сказать',
        vocal: 'gawari̒t, ßkasа́t',
      },
      {
        en: 'knowledge',
        ru: 'знать',
        vocal: 'snat',
      },
      {
        en: 'see',
        ru: 'видеть, смотреть',
        vocal: 'wi̒dit, smatrе́t',
      },
      {
        en: 'want',
        ru: 'хотеть',
        vocal: 'chatе́t',
      },
      {
        en: 'Find',
        ru: 'находить (найти)',
        vocal: 'nachadi̒t (najti̒)',
      },
      {
        en: 'tell',
        ru: 'рассказывать (рассказать)',
        vocal: 'raßkа́sywat (raßkasа́t)',
      },
      {
        en: 'ask',
        ru: 'спрашивать (спросить)',
        vocal: 'ßprа́schiwat (ßpraßi̒t)',
      },
      {
        en: 'to attempt',
        ru: 'пытаться, пробовать',
        vocal: 'pytа́tza, pro̒bawat',
      },
      {
        en: 'call',
        ru: 'звонить',
        vocal: 'swani̒t',
      },
    ],
  },
  {
    en: 'important adjectives',
    vocabularies: [
      {
        en: 'beautiful',
        ru: 'красивый',
        vocal: 'kraßi̒wyj',
      },
      {
        en: 'ugly',
        ru: 'уродливый, некрасивый',
        vocal: 'uro̒dliwyj, nikraßi̒wyj',
      },
      {
        en: 'high',
        ru: 'высокий',
        vocal: 'wyßo̒kij',
      },
      {
        en: 'small',
        ru: 'маленький',
        vocal: 'mа́linkij',
      },
      {
        en: 'large',
        ru: 'большой',
        vocal: 'balscho̒j',
      },
      {
        en: 'New',
        ru: 'новый',
        vocal: 'no̒wyj',
      },
      {
        en: 'long',
        ru: 'длинный, долгий',
        vocal: 'dli̒nyj',
      },
      {
        en: 'Great',
        ru: 'прекрасный, чудесный',
        vocal: 'prikrа́ßnyj',
      },
      {
        en: 'old',
        ru: 'старый',
        vocal: 'ßtа́ryj',
      },
      {
        en: 'young',
        ru: 'молодой',
        vocal: 'malado̒j',
      },
      {
        en: 'different',
        ru: 'другой',
        vocal: 'drugo̒j',
      },
      {
        en: 'important',
        ru: 'важный',
        vocal: 'wа́shnyj',
      },
      {
        en: 'bad',
        ru: 'плохой',
        vocal: 'placho̒j',
      },
      {
        en: 'funny',
        ru: 'весёлый',
        vocal: 'wißjo̒lyj',
      },
      {
        en: 'serious',
        ru: 'серьёзный',
        vocal: 'ßirjo̒snyj',
      },
      {
        en: 'strongly',
        ru: 'сильный',
        vocal: 'ßi̒lnyj',
      },
      {
        en: 'easy',
        ru: 'простой',
        vocal: 'praßto̒j',
      },
      {
        en: 'heavy',
        ru: 'сложный, трудный, тяжёлый',
        vocal: 'ßlo̒shnyj, tru̒dnyj, tjasho̒lyj',
      },
      {
        en: 'poor',
        ru: 'бедный',
        vocal: 'bе́dnyj',
      },
      {
        en: 'rich',
        ru: 'богатый',
        vocal: 'bagа́tyj',
      },
    ],
  },
];
